/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useIndexPrice } from '@/app/hooks/trade/indexprice';
import { View } from '@/styles/reactnative';
import { ThemeContext } from '@/theme/ThemeProvider';
import API from '@/utils/api';
import { message } from 'antd';
import BigNumber from 'bignumber.js';
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS } from '../../../../../constants';
import { SOCKET_URL, NEW_API_URL } from '../../../../../constants/APIKEYS';
import { useTradeApi } from '../../../../../hooks/trade/tradeApi'; // ✅ Context 기반 API Hook 사용
import { useChartDataFeed } from '../../../../../hooks/trade/chartDataFeed';
import { useTradeModalStore } from '../../../../../hooks/trade/modalStore';
import { useTradePosition } from '../../../../../hooks/trade/tradePosition';
import { useTradeSocket } from '../../../../../hooks/trade/tradeSocket';
import useTradeStore from '../../../../../hooks/trade/tradeStore';
import { useExchangeStore } from '../../../../../hooks/trade/exchangeStore';
import { widgetOptions } from './ChartUtiles';
import { ChartContainerWrapper } from './styles';
import { getBigNumber } from '@utils/getBigNumber.tsx';
import { useNavigate } from 'react-router-dom';
import console from 'node:console';
import i18next from 'i18next';
import { truncateWithComma } from '@utils/Truncate.ts';
import { formatDecimal } from '@utils/formatDecimal';
import { useBinanceWebSocketStore } from '@app/hooks/binanceWebsocketStore.ts';
import { useCiTradeWebSocketStore } from '@app/hooks/ciTradeWebsocketStore.ts';
import { CustomDatafeed } from '@app/organisms/Trade/TradeChart/TradeChartSection/ChartContainer/CustomDatafeed.tsx';
import EditCheckPositionModal from '@components/EditCheckPositionModal';
import { useMitOrder } from '@app/hooks/trade/mitorder.tsx';
import { useChartThemeStore } from '@/app/hooks/trade/chartThemeStore';
import { CHART_THEMES } from '@/constants/chartThemes';
import { applyChartTheme } from '@/utils/chartThemeUtils';
import { useDemoTradingStore } from '@/app/hooks/trade/demoTradingStore';

declare global {
  interface Window {
    Datafeeds: any;
  }
}

let orderlines: Array<{
  id: string | number;
  line: any;
  type?: string;
  item?: any;
}> = [];
const ChartContainer = ({ isDragging, tab }) => {
  const CHART_PARAM_STORAGE = 'TVWIDGET';

  const { drawerBgColor } = useContext(ThemeContext).theme.COLORS;
  const { isDarkMode } = useContext(ThemeContext);
  const ref = useRef<any>(null);
  const tvWidgetRef = useRef<any>(null);
  const isChartLoading = useRef(false); // ✅ loadchart 충돌 방지용 ref
  const { t, i18n } = useTranslation();
  const { createOrder, cancelOrder, token } = useTradeApi(); // ✅ Demo/Real 자동 선택
  const { isDemoMode } = useDemoTradingStore(); // ✅ Demo/Real 모드 확인

  // 차트 색상 테마
  const { selectedTheme } = useChartThemeStore();
  const currentChartTheme = CHART_THEMES.find((t) => t.id === selectedTheme) || CHART_THEMES[0];

  const [open, setOpen] = React.useState(false);
  const [long_short, setLongShort] = React.useState('L');
  const [orderId, setOrderId] = React.useState(null);
  const [orderPrice, setOrderPrice] = React.useState(0);
  const [orderItem, setOrderItem] = React.useState({});

  const { data: tradeModalStore } = useTradeModalStore();

  const [loading, setLoading] = React.useState(true);

  const { data: updatechart, mutate: mutateUpdateChart } = useChartDataFeed();

  const {
    ep_id,
    pairs,
    mutate: TradeStoreMutate,
    data: TradeStoreData,
  } = useTradeStore();

  const { mutate: muateSocket } = useTradeSocket(SOCKET_URL);

  const { data: rawPosition, orderlist: rawList, mutate } = useTradePosition();
  const { data: mitdata, mutate: mutateMit } = useMitOrder();
  const GtradePrice = useCiTradeWebSocketStore((s) => s.tradePrice);

  // 현재 ep_id에 대한 포지션과 주문 필터링
  const position = rawPosition?.filter(
    (pos) => pos.exchange_pairs_id === ep_id
  );
  const list = rawList?.filter((order) => order.exchange_pairs_id === ep_id);

  // console.log('filtered position for ep_id:', ep_id, position);

  const { getPrice } = useIndexPrice(ep_id);

  // ExchangeStore에서 거래쌍 데이터 가져오기
  const { EPs } = useExchangeStore();

  // 종목쌍 차트로 전달
  useEffect(() => {
    if (EPs && EPs.length > 0) {
      CustomDatafeed.init(EPs);
    }
  }, [EPs]);

  // PnL 값을 저장하는 상태 객체로 변경 (포지션 ID를 키로 사용)
  const [pnlValues, setPnlValues] = useState<Record<string | number, string>>(
    {}
  );

  const tradePrice = useCiTradeWebSocketStore((s) => s.tradePrice);

  const sendOrder = useCallback(
    async (item) => {
      let checkamount = getBigNumber(item?.amount).toNumber();

      if (item?.amount < checkamount) {
        checkamount = item?.amount;
      }

      if (!item?.amount) {
        message.error('Check order amount.');
      }

      const orderParams = {
        ep_id: item?.exchange_pairs_id,
        main_sub: 'M',
        long_short: item?.long_short === 'L' ? 'S' : 'L',
        cross_iso: item?.cross_iso,
        leverage: item?.leverage,
        reduce_position: 1,
        post_only: 1,
        limit_market: 'M',
        price: Number(tradePrice) || getPrice(item?.exchange_pairs_id),
        amount: checkamount,
        position_id: item?.id,
      };

      const result = await createOrder(orderParams); // ✅ Context 기반 API 호출
      if (result?.result?.success) {
        setTimeout(() => {
          mutate();
        }, 500);
        message.success(`${t('positionClosedSuccessfully')}`);
      } else {
        if (result?.result?.message) {
          message.error(`${t(result?.result?.message)}`);
        }
      }
    },
    [getPrice, token, mutate]
  );

  // 차트 분석 템플릿 로드 함수
  const loadStudy = useCallback(() => {
    if (!tvWidgetRef.current) return;

    const savedStr = localStorage.getItem(CHART_PARAM_STORAGE);
    if (savedStr) {
      try {
        const saved = JSON.parse(savedStr);
        if (!saved) {
          return;
        }

        if (saved.content) {
          tvWidgetRef.current.load(saved.content);
        }

        if (saved.studyTemplate) {
          tvWidgetRef.current
            .activeChart()
            .applyStudyTemplate(saved.studyTemplate);
        } else {
          console.log('ERR');
        }
      } catch (e) {
        console.error(e);
      }
    } else {
      // 신규 차트: MA CROSS (EMA 9 + EMA 20) 자동 추가
      if (!tvWidgetRef.current) return;
      try {
        // EMA 9 (단기)
        tvWidgetRef.current.activeChart().createStudy('Moving Average Exponential', false, false, {
          length: 9
        });

        // EMA 20 (장기)
        tvWidgetRef.current.activeChart().createStudy('Moving Average Exponential', false, false, {
          length: 20
        });

        console.log('MA CROSS (EMA 9 + EMA 20) 추가 완료');
      } catch (e) {
        console.error('MA CROSS 지표 추가 실패:', e);
      }
    }

    const persistSafely = (payload: any) => {
      try {
        const json = JSON.stringify(payload);
        if (json.length > 4500000) {
          localStorage.setItem(CHART_PARAM_STORAGE, '');
          return;
        }
        localStorage.setItem(CHART_PARAM_STORAGE, json);
      } catch {
        try {
          localStorage.removeItem(CHART_PARAM_STORAGE);
        } catch {}
      }
    };

    // 구독은 한 번만 설정
    tvWidgetRef.current.subscribe('onAutoSaveNeeded', function () {
      tvWidgetRef.current.save(function (savedContent) {
        try {
          const savedTemplate = tvWidgetRef.current
            .activeChart()
            .createStudyTemplate({ saveInterval: false });

          persistSafely({
            studyTemplate: savedTemplate,
            content: savedContent,
          });
        } catch {
          try {
            localStorage.removeItem(CHART_PARAM_STORAGE);
          } catch {}
        }
      });
    });
    muateSocket();
  }, [tvWidgetRef, muateSocket]);

  // 중복 구독 제거: 위의 loadStudy 내에서만 구독

  const [chartReady, setChartReady] = useState(false);
  const positionLinesRef = useRef<Map<string | number, any>>(new Map());
  const liquidationLinesRef = useRef<Map<string | number, any>>(new Map());
  const triggerLinesRef = useRef<Map<string | number, any>>(new Map());
  const prevPosPricesRef = useRef<Record<string | number, number>>({});
  const resolutionChangeRef = useRef(false);
  const [pnlText, setPnlText] = useState<string>('0');

  // 분봉 변경 처리를 위한 useEffect
  useEffect(() => {
    // ✅ loadchart 중이면 무시 (충돌 방지)
    if (isChartLoading.current) {
      console.log('[Chart] loadchart 중이므로 setResolution 스킵');
      return;
    }

    if (!tvWidgetRef.current || !tab || !chartReady) return;

    resolutionChangeRef.current = true;

    const updateResolution = async () => {
      try {
        const chart = tvWidgetRef.current.chart();
        if (!chart) return;

        const res = tab?.includes('m')
          ? tab?.split('m')[0]
          : tab?.toUpperCase();
        await chart.setResolution(res);

        // 분봉 변경 완료 후 약간의 딜레이를 두고 플래그 해제
        setTimeout(() => {
          resolutionChangeRef.current = false;
        }, 500);
      } catch (error) {
        console.error('Resolution update error:', error);
        resolutionChangeRef.current = false;
      }
    };

    updateResolution();
  }, [tab, chartReady]);

  // 포지션 라인 그리기 로직 수정
  useEffect(() => {
    if (
      !tvWidgetRef.current ||
      !chartReady ||
      !tradeModalStore?.showpos ||
      resolutionChangeRef.current
    )
      return;

    const drawPositionLines = async () => {
      const chart = tvWidgetRef.current?.chart();
      if (!chart) return;

      try {
        // 현재 표시되어야 할 라인들의 ID 집합
        const currentLineIds = new Set([
          ...(position?.map((p) => p.id) || []),
          ...(list?.map((l) => l.id) || []),
        ]);

        // 더 이상 필요없는 라인들 제거
        for (const [id, line] of positionLinesRef.current.entries()) {
          if (!currentLineIds.has(id)) {
            try {
              if (line?.remove) {
                line.remove();
                positionLinesRef.current.delete(id);
              }
            } catch (e) {
              console.warn('Failed to remove old line:', e);
            }
          }
        }

        // 청산가 라인 제거 (포지션이 없어진 경우)
        const positionIds = new Set(position?.map((p) => p.id) || []);
        for (const [id, line] of liquidationLinesRef.current.entries()) {
          if (!positionIds.has(id)) {
            try {
              if (line?.remove) {
                line.remove();
                liquidationLinesRef.current.delete(id);
              }
            } catch (e) {
              console.warn('Failed to remove liquidation line:', e);
            }
          }
        }

        const remainingPositionIds = new Set(position?.map((p) => p.id));

        for (const orderline of [...orderlines]) {
          const isTPorSL = orderline.type === 'TP' || orderline.type === 'SL';
          const baseId =
            typeof orderline.id === 'string'
              ? orderline.id.replace(/^TP|SL/, '')
              : '';

          if (isTPorSL && !remainingPositionIds.has(+baseId)) {
            try {
              orderline.line?.remove?.();
              orderlines = orderlines.filter((l) => l !== orderline);
            } catch (e) {
              console.warn(
                'Failed to remove TP/SL line for closed position',
                e
              );
            }
          }
        }

        if (!Array.isArray(mitdata?.MIT2) || mitdata?.MIT2.length === 0) {
          for (const [id, line] of triggerLinesRef.current.entries()) {
            try {
              line?.remove?.();
            } catch (e) {
              console.warn('Failed to remove trigger line:', e);
            }
          }
          triggerLinesRef.current.clear();
        }

        if (Array.isArray(mitdata?.MIT2)) {
          for (const mit of mitdata?.MIT2) {
            if (!mit) continue;

            try {
              let orderLine = triggerLinesRef.current.get(mit.created_at);

              if (!orderLine) {
                orderLine = chart.createOrderLine();
                if (!orderLine) continue;
                triggerLinesRef.current.set(mit.created_at, orderLine);
              }

              if (mit?.trigger_price && mit?.trigger_type) {
                orderLine
                  .setText(t('trigger') + ' / ' + formatDecimal(mit?.trigger_price, TradeStoreData?.dp || 2))
                  .setLineLength(80)
                  .setLineWidth(1)
                  .setBodyFont(
                    "600 14px 'Noto Sans KR','Segoe UI',Roboto,'Apple SD Gothic Neo','Malgun Gothic',Arial,sans-serif"
                  )
                  .setQuantityFont(
                    "600 14px 'Noto Sans KR','Segoe UI',Roboto,'Apple SD Gothic Neo','Malgun Gothic',Arial,sans-serif"
                  )
                  .setQuantity(
                    BigNumber(mit?.amount * mit?.leverage).toFormat(
                      TradeStoreData?.dp2 || 4
                    )
                  )
                  .setPrice(BigNumber(mit?.trigger_price).toNumber())
                  .onCancel((e) => {
                    mutateMit(
                      [
                        // {...mit,
                        //   trigger_price: 0,
                        // }
                      ],
                      TradeStoreData?.ep_id
                    );
                  })
                  .onMove(() => {
                    const currentPrice = orderLine.getPrice();

                    mutateMit(
                      [
                        {
                          ...mit,
                          trigger_price: currentPrice,
                          trigger_type: GtradePrice
                            ? GtradePrice >= currentPrice
                              ? 'BIG'
                              : 'SML'
                            : '',
                        },
                      ],
                      TradeStoreData?.ep_id
                    );
                  })
                  .setLineStyle(2);
              }
            } catch (error) {
              const err = error as Error;
              if (err?.message !== 'Value is null') {
                console.error('Trigger line update/creation error:', err);
              }
            }
          }
        }

        // 포지션 라인 업데이트/생성
        if (Array.isArray(position)) {
          for (const item of position) {
            if (!item) continue;

            try {
              let posLine = positionLinesRef.current.get(item.id);

              const amount = BigNumber(item?.amount)
                .multipliedBy(item?.leverage)
                .toFormat(item?.dp || 4);
              const prevPrice = prevPosPricesRef.current[item.id];

              if (!posLine || prevPrice !== item.price) {
                prevPosPricesRef.current[item.id] = item.price;

                if (posLine?.remove) {
                  posLine.remove();
                }

                posLine = chart?.createPositionLine();
                posLine.setQuantity(amount);
                posLine.setPrice(item.price);
                posLine.setBodyTextColor(
                  item.long_short === 'L' ? COLORS.lightGreen : COLORS.lightRed
                );
                posLine.setBodyBorderColor(
                  item.long_short === 'L' ? COLORS.lightGreen : COLORS.lightRed
                );
                posLine.setQuantityBorderColor(
                  item.long_short === 'L' ? COLORS.lightGreen : COLORS.lightRed
                );
                posLine.setQuantityBackgroundColor(
                  item.long_short === 'L' ? COLORS.lightGreen : COLORS.lightRed
                );
                posLine.setLineColor(
                  item.long_short === 'L' ? COLORS.lightGreen : COLORS.lightRed
                );
                // 가독성 향상을 위한 폰트 및 크기 확대
                posLine.setBodyFont(
                  "600 14px 'Noto Sans KR','Segoe UI',Roboto,'Apple SD Gothic Neo','Malgun Gothic',Arial,sans-serif"
                );
                posLine.setQuantityFont(
                  "600 14px 'Noto Sans KR','Segoe UI',Roboto,'Apple SD Gothic Neo','Malgun Gothic',Arial,sans-serif"
                );
                posLine.setLineLength(-1, 'pixel');
                posLine.setLineWidth(1);
                positionLinesRef.current.set(item.id, posLine);
                posLine.onClose(() => sendOrder(item));
              }

              // 청산가 라인 그리기
              const liquidPrice = BigNumber(item?.liquid_price);
              if (!liquidPrice.isNegative() && liquidPrice.toNumber() > 0) {
                let liqLine = liquidationLinesRef.current.get(item.id);
                const liqId = `liq_${item.id}`;

                if (!liqLine) {
                  liqLine = chart?.createPositionLine();
                  if (liqLine) {
                    liqLine.setQuantity('');
                    liqLine.setPrice(liquidPrice.toNumber());
                    liqLine.setText(t('liqPrice') + ' ' + formatDecimal(liquidPrice.toNumber(), TradeStoreData?.dp || 2));
                    liqLine.setBodyTextColor('#FF8C00');
                    liqLine.setBodyBorderColor('#FF8C00');
                    liqLine.setBodyBackgroundColor('rgba(255, 140, 0, 0.1)');
                    liqLine.setQuantityBorderColor('#FF8C00');
                    liqLine.setQuantityBackgroundColor('#FF8C00');
                    liqLine.setLineColor('#FF8C00');
                    liqLine.setBodyFont(
                      "600 12px 'Noto Sans KR','Segoe UI',Roboto,'Apple SD Gothic Neo','Malgun Gothic',Arial,sans-serif"
                    );
                    liqLine.setLineLength(-1, 'pixel');
                    liqLine.setLineWidth(1);
                    liqLine.setLineStyle(2); // 점선
                    liquidationLinesRef.current.set(item.id, liqLine);
                  }
                } else {
                  // 가격 업데이트
                  liqLine.setPrice(liquidPrice.toNumber());
                  liqLine.setText(t('liqPrice') + ' ' + formatDecimal(liquidPrice.toNumber(), TradeStoreData?.dp || 2));
                }
              }

              const TPSL = item?.tpsl?.[0];

              if (TPSL) {
                if (+TPSL?.tp) {
                  const tpId = 'TP' + item?.id;
                  const tpExists = orderlines.find((line) => line.id === tpId);
                  const tp = tpExists?.line?._data?.bodyText.split(' / ')[1];
                  const isSame = tp == +TPSL?.tp;

                  if (!tpExists || !isSame) {
                    if (tpExists) {
                      tpExists.line?.remove?.();
                      orderlines = orderlines.filter((l) => l.id !== tpId);
                    }

                    const orderLine = tvWidgetRef?.current
                      ?.chart()
                      ?.createOrderLine();

                    orderlines.push({
                      id: 'TP' + item?.id,
                      line: orderLine,
                      type: 'TP',
                    });

                    const LONGSHORT = item?.long_short == 'L' ? 'S' : 'L';

                    orderLine
                      .setText(t('TP') + ' / ' + formatDecimal(TPSL?.tp, TradeStoreData?.dp || 2))
                      .setLineLength(80)
                      .setLineWidth(1)
                      .setBodyFont(
                        "600 14px 'Noto Sans KR','Segoe UI',Roboto,'Apple SD Gothic Neo','Malgun Gothic',Arial,sans-serif"
                      )
                      .setQuantityFont(
                        "600 14px 'Noto Sans KR','Segoe UI',Roboto,'Apple SD Gothic Neo','Malgun Gothic',Arial,sans-serif"
                      )
                      .onCancel((e) => {
                        API.post('/trade/tpsl', '' + token, {
                          posId: item?.id,
                          tp: 0,
                        }, NEW_API_URL).then((res) => {
                          message.success(`${t('success')}`);

                          orderLine.remove?.();

                          const tpId = 'TP' + item?.id;
                          const index = orderlines.findIndex(
                            (line) => line.id === tpId
                          );
                          if (index !== -1) {
                            orderlines.splice(index, 1);
                          }

                          mutate();
                        });
                      })
                      .onMove(() => {
                        const currentPrice = orderLine.getPrice();

                        API.post('/trade/tpsl', '' + token, {
                          posId: item?.id,
                          tp: currentPrice,
                        }, NEW_API_URL).then((res) => {
                          message.success(`${t('success')}`);

                          mutate();
                          // console.log('TP 드래그 이동 완료',);
                          orderLine.setText(t('TP') + ' / ' + formatDecimal(currentPrice, TradeStoreData?.dp || 2));
                        });

                        // console.log('TP 드래그', currentPrice);
                      })
                      .setBodyTextColor(
                        LONGSHORT === 'L' ? COLORS.lightGreen : COLORS.lightRed
                      )
                      .setBodyBorderColor(
                        LONGSHORT === 'L' ? COLORS.lightGreen : COLORS.lightRed
                      )
                      .setQuantityBorderColor(
                        LONGSHORT === 'L' ? COLORS.lightGreen : COLORS.lightRed
                      )
                      .setQuantityBackgroundColor(
                        LONGSHORT === 'L' ? COLORS.lightGreen : COLORS.lightRed
                      )

                      .setLineColor(
                        LONGSHORT === 'L' ? COLORS.lightGreen : COLORS.lightRed
                      )
                      .setLineStyle(2)
                      .setQuantity(0)
                      .setPrice(+TPSL?.tp);
                  }
                }

                // const existingSL = orderlines.find((line) => line.id === 'SL' + item?.id);
                //
                // if (existingSL) {
                //   try {
                //     existingSL.line?.remove?.();
                //     orderlines = orderlines.filter((l) => l.id !== 'SL' + item?.id);
                //   } catch (e) {
                //     console.warn('SL line remove failed', e);
                //   }
                // }

                if (+TPSL?.sl) {
                  const slId = 'SL' + item?.id;
                  const slExists = orderlines.find((line) => line.id === slId);
                  const sl = slExists?.line?._data?.bodyText.split(' / ')[1];
                  const isSame = sl == +TPSL?.sl;

                  if (!slExists || !isSame) {
                    if (slExists) {
                      slExists.line?.remove?.();
                      orderlines = orderlines.filter((l) => l.id !== slId);
                    }

                    // console.log('TPSL SL', +TPSL?.sl)
                    const orderLine = tvWidgetRef?.current
                      ?.chart()
                      ?.createOrderLine();

                    orderlines.push({
                      id: 'SL' + item?.id,
                      line: orderLine,
                      type: 'SL',
                    });

                    const LONGSHORT = item?.long_short == 'L' ? 'S' : 'L';

                    orderLine
                      .setText(t('SL') + ' / ' + formatDecimal(TPSL?.sl, TradeStoreData?.dp || 2))
                      .setLineLength(80)
                      .setBodyFont(
                        "600 14px 'Noto Sans KR','Segoe UI',Roboto,'Apple SD Gothic Neo','Malgun Gothic',Arial,sans-serif"
                      )
                      .setQuantityFont(
                        "600 14px 'Noto Sans KR','Segoe UI',Roboto,'Apple SD Gothic Neo','Malgun Gothic',Arial,sans-serif"
                      )
                      .onCancel((e) => {
                        //console.log('SL 라인 삭제 onCancel 동작')

                        API.post('/trade/tpsl', '' + token, {
                          posId: item?.id,
                          sl: 0,
                        }, NEW_API_URL).then((res) => {
                          message.success(`${t('success')}`);

                          orderLine.remove?.();

                          const slId = 'SL' + item?.id;
                          const index = orderlines.findIndex(
                            (line) => line.id === slId
                          );
                          if (index !== -1) {
                            orderlines.splice(index, 1);
                          }

                          mutate();
                        });
                      })
                      .onMove(() => {
                        const currentPrice = orderLine.getPrice();

                        API.post('/trade/tpsl', '' + token, {
                          posId: item?.id,
                          sl: currentPrice,
                        }, NEW_API_URL).then((res) => {
                          message.success(`${t('success')}`);

                          mutate();

                          orderLine.setText(t('SL') + ' / ' + formatDecimal(currentPrice, TradeStoreData?.dp || 2));
                        });

                        // console.log('SL 드래그', currentPrice);
                      })
                      .setBodyTextColor(
                        LONGSHORT === 'L' ? COLORS.lightGreen : COLORS.lightRed
                      )
                      .setBodyBorderColor(
                        LONGSHORT === 'L' ? COLORS.lightGreen : COLORS.lightRed
                      )
                      .setQuantityBorderColor(
                        LONGSHORT === 'L' ? COLORS.lightGreen : COLORS.lightRed
                      )
                      .setQuantityBackgroundColor(
                        LONGSHORT === 'L' ? COLORS.lightGreen : COLORS.lightRed
                      )

                      .setLineColor(
                        LONGSHORT === 'L' ? COLORS.lightGreen : COLORS.lightRed
                      )
                      .setLineStyle(2)
                      .setQuantity(0)
                      .setPrice(+TPSL?.sl);
                  }
                }
              }
            } catch (error) {
              const err = error as Error;
              if (err?.message !== 'Value is null') {
                console.error('Position line update/creation error:', err);
              }
            }
          }
        }

        // 주문 라인 업데이트/생성
        if (Array.isArray(list)) {
          for (const item of list) {
            if (!item || item?.limit_market === 'M') continue;

            // console.log('list', list)

            try {
              let orderLine = positionLinesRef.current.get(item.id);

              if (!orderLine) {
                orderLine = chart.createOrderLine();
                if (!orderLine) continue;
                positionLinesRef.current.set(item.id, orderLine);
              }

              orderLine
                .setText(t('limit') + ' / ' + formatDecimal(item?.order_price, TradeStoreData?.dp || 2))
                .setLineLength(75)
                .onCancel(() => {
                  // ✅ Demo/Real 자동 선택
                  cancelOrder({
                    orderid: item?.id,
                  }).then(() => {
                    mutate();
                    message.success('CANCELED');
                  });
                })
                .setLineWidth(1)
                .setBodyFont(
                  "600 14px 'Noto Sans KR','Segoe UI',Roboto,'Apple SD Gothic Neo','Malgun Gothic',Arial,sans-serif"
                )
                .setQuantityFont(
                  "600 14px 'Noto Sans KR','Segoe UI',Roboto,'Apple SD Gothic Neo','Malgun Gothic',Arial,sans-serif"
                )
                .setBodyTextColor(
                  item.long_short === 'L' ? COLORS.lightGreen : COLORS.lightRed
                )
                .setBodyBorderColor(
                  item.long_short === 'L' ? COLORS.lightGreen : COLORS.lightRed
                )
                .setQuantityBorderColor(
                  item.long_short === 'L' ? COLORS.lightGreen : COLORS.lightRed
                )
                .setQuantityBackgroundColor(
                  item.long_short === 'L' ? COLORS.lightGreen : COLORS.lightRed
                )
                .setLineColor(
                  item.long_short === 'L' ? COLORS.lightGreen : COLORS.lightRed
                )
                .setPrice(item?.order_price)
                .setQuantity(
                  BigNumber(item?.amount * item?.leverage).toFormat(
                    TradeStoreData?.dp2 || 4
                  )
                  // BigNumber(item?.amount)
                  //   .multipliedBy(item?.leverage)
                  //   .toFormat(item?.dp)
                )
                .onMove(() => {
                  const currentPrice = orderLine.getPrice();

                  setOrderId(item?.id);
                  setOrderPrice(currentPrice);
                  setOrderItem(item);
                  setOpen(true);

                  // console.log('드래그 끝', currentPrice, item, TradeStoreData);
                });
            } catch (error) {
              console.error('Order line update/creation error:', error);
            }
          }
        }
      } catch (error) {
        const err = error as Error;
        console.error('Draw position lines error:', err);
      }
    };

    const timeoutId = setTimeout(drawPositionLines, 100);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [position, list, ep_id, chartReady, tradeModalStore?.showpos, sendOrder]);

  // 페이지 이동을 위한 navigate 함수 추가
  const navigate = useNavigate();

  // 심볼 변경 시 직접 페이지 이동하는 함수
  // const handleDirectNavigation = useCallback((selectedEpId: string | number) => {
  //   if (selectedEpId && selectedEpId !== ep_id) {
  //     // 페이지 이동
  //     window.location.href = `/trade/${selectedEpId}`;
  //     return true;
  //   }
  //   return false;
  // }, [ep_id]);

  useEffect(() => {
    if (!tvWidgetRef.current || !chartReady || !pairs) return;

    const chart = tvWidgetRef.current.chart?.();
    if (!chart || typeof chart.setSymbol !== 'function') return;

    const interval = tab?.includes('m')
      ? tab?.split('m')[0]
      : tab?.toUpperCase() || '1';

    chart.setSymbol(pairs, interval, () => {
      console.log(`Change Symbol - ${pairs} (${interval})`);
    });
  }, [pairs, chartReady, tab]);

  useEffect(() => {
    if (!tvWidgetRef.current || !chartReady) return;

    // TradingView 위젯의 시간대 변경 이벤트를 감지하여 localStorage에 저장
    const chart = tvWidgetRef.current.chart();
    if (!chart) return;

    const handleIntervalChange = () => {
      try {
        const currentInterval = chart.resolution();
        if (currentInterval) {
          // TradingView 형식을 저장용 형식으로 변환
          const intervalMap = {
            '1': '1m',
            '3': '3m',
            '5': '5m',
            '15': '15m',
            '30': '30m',
            '60': '1h',
            '120': '2h',
            '240': '4h',
            '360': '6h',
            '480': '8h',
            '720': '12h',
            '1D': '1d',
            '1W': '1w',
            '1M': '1M',
          };

          const reactInterval = intervalMap[currentInterval] || currentInterval;
          localStorage.setItem('CHART_TIMETAB', reactInterval);
        }
      } catch (error) {
        console.error('Interval save error:', error);
      }
    };

    // 시간대 변경 이벤트 구독
    const subscription = chart
      .onIntervalChanged?.()
      .subscribe(null, handleIntervalChange);

    return () => {
      if (subscription && typeof subscription.unsubscribe === 'function') {
        subscription.unsubscribe();
      }
    };
  }, [chartReady]);

  const handleDirectNavigation = useCallback(
    (selectedEpId: string | number) => {
      if (selectedEpId && selectedEpId !== ep_id) {
        const selected = EPs.find((ep) => ep.id === selectedEpId);
        if (selected) {
          mutate({
            ep_id: selected.id,
            ...selected,
          });

          TradeStoreMutate({
            ep_id: selected.id,
            ...selected,
          });

          // isDemoMode 상태로 demo/real 구분
          const basePath = isDemoMode ? '/demo-trade' : '/trade';
          navigate(`${basePath}/${selected.id}`, { replace: true });

          return true;
        }
      }
      return false;
    },
    [ep_id, EPs, mutate]
  );

  // 심볼 형식 정규화 함수 추가
  const normalizeSymbol = useCallback((symbol: string): Array<string> => {
    if (!symbol) return [];

    // 다양한 형식의 심볼 변환 처리
    const normalizedFormats: string[] = [];

    // 원본 형식 보존
    normalizedFormats.push(symbol);

    // "ETHUSDT" -> "ETH/USDT" 변환
    if (!symbol.includes('/')) {
      // 일반적인 암호화폐 토큰 심볼 길이는 2-5자
      const commonBaseTokens = [
        'USDT',
        'USD',
        'BTC',
        'ETH',
        'BNB',
        'BUSD',
        'DAI',
        'USDC',
      ];

      for (const baseToken of commonBaseTokens) {
        if (symbol.endsWith(baseToken)) {
          const mainToken = symbol.slice(0, symbol.length - baseToken.length);
          normalizedFormats.push(`${mainToken}/${baseToken}`);
          break;
        }
      }
    }

    // "ETH/USDT" -> "ETHUSDT" 변환
    if (symbol.includes('/')) {
      normalizedFormats.push(symbol.replace('/', ''));
    }

    return normalizedFormats;
  }, []);

  // 심볼에 해당하는 EP ID 찾기 함수 개선
  const findEpIdBySymbol = useCallback(
    (symbolName: string) => {
      if (!EPs || !symbolName) return null;

      // 다양한 형식의 심볼명 생성
      const possibleSymbolFormats = normalizeSymbol(symbolName);

      // 각 가능한 형식에 대해 검색
      for (const format of possibleSymbolFormats) {
        // 정확히 일치하는 경우 먼저 확인
        let matchedEP = EPs.find((ep) => ep.pairs === format);

        // 정확히 일치하는 결과가 없으면 대소문자 무시하고 비교
        if (!matchedEP) {
          matchedEP = EPs.find(
            (ep) => ep.pairs && ep.pairs.toLowerCase() === format.toLowerCase()
          );
        }

        // 그래도 없으면 부분 문자열 포함 여부로 검색 (마지막 수단)
        if (!matchedEP) {
          matchedEP = EPs.find(
            (ep) =>
              ep.pairs &&
              (format.includes(ep.pairs) ||
                ep.pairs.includes(format) ||
                ep.pairs.replace('/', '') === format ||
                format.replace('/', '') === ep.pairs)
          );
        }

        if (matchedEP && matchedEP.id) {
          return matchedEP.id;
        }
      }

      // exchange_pairs_id로 직접 검색 시도 (사용자 제안 반영)
      const matchByExchangePairsId = EPs.find(
        (ep) =>
          ep.exchange_pairs_id === symbolName ||
          String(ep.exchange_pairs_id) === symbolName
      );

      if (matchByExchangePairsId) {
        return matchByExchangePairsId.id;
      }

      return null;
    },
    [EPs, normalizeSymbol]
  );

  // 심볼 변경 이벤트를 직접 처리하는 함수
  const handleSymbolChange = useCallback(
    (symbolInfo: any) => {
      if (!symbolInfo) return;

      let symbolName: string | null = null;

      // 다양한 형태의 심볼 정보 처리
      if (typeof symbolInfo === 'string') {
        symbolName = symbolInfo;
      } else if (symbolInfo.name) {
        symbolName = symbolInfo.name;
      } else if (symbolInfo.symbol) {
        symbolName = symbolInfo.symbol;
      }

      if (symbolName) {
        const foundEpId = findEpIdBySymbol(symbolName);
        if (foundEpId) {
          handleDirectNavigation(foundEpId);
        }
      }
    },
    [findEpIdBySymbol, handleDirectNavigation, normalizeSymbol]
  );

  // loadchart 함수 수정 - 심볼 선택 이벤트 콜백 추가
  const loadchart = useCallback(() => {
    if (!pairs || !ep_id) return;

    // 기존 위젯이 있으면 먼저 제거
    if (tvWidgetRef.current) {
      try {
        tvWidgetRef.current.remove();
      } catch (e) {
        console.warn('Failed to remove existing widget', e);
      }
      tvWidgetRef.current = null;
    }

    isChartLoading.current = true; // ✅ 로딩 시작

    setLoading(true);
    setChartReady(false);
    resolutionChangeRef.current = false;

    positionLinesRef.current.clear();
    liquidationLinesRef.current.clear();
    orderlines = [];
    // PnL 값 초기화
    setPnlValues({});

    // DOM 컨테이너가 준비될 때까지 대기
    const container = document.getElementById('tv_chart_container');
    if (!container) {
      console.warn('Chart container not ready, retrying...');
      isChartLoading.current = false;
      setLoading(false);
      return;
    }

    // 거래쌍 목록 추출
    const exchangePairs = EPs ? EPs.map((ep) => ep.pairs) : [];

    // widgetOptions에 거래쌍 목록 및 심볼 선택 콜백 전달
    const widgetOptionsData = widgetOptions(
      tvWidgetRef,
      pairs,
      ep_id,
      updatechart,
      mutateUpdateChart,
      tab,
      i18n.language,
      isDarkMode,
      token,
      exchangePairs,
      EPs, // 전체 거래쌍 데이터 전달
      handleDirectNavigation, // 직접 페이지 이동 함수 전달
      currentChartTheme // 차트 색상 테마
    );

    try {
      const tvWidget = new (window as any).TradingView.widget({
        ...widgetOptionsData,
        container_id: 'tv_chart_container',
        datafeed: widgetOptionsData.datafeed,
        library_path: '/charting_library/',
        locale: i18next.language === 'ko' ? 'ko' : 'en',
        fullscreen: false,
        autosize: true,
        theme: isDarkMode ? 'dark' : 'light', // 명시적으로 테마 설정 추가
      });

    // 초기 priceType 설정
    if (widgetOptionsData?.datafeed?.setPriceType) {
      widgetOptionsData.datafeed.setPriceType('last');
    }

    const handleUpdatePriceType = (newPriceType: string) => {
      // 먼저 CustomDatafeed에 새로운 priceType 설정
      if (widgetOptionsData?.datafeed?.setPriceType) {
        widgetOptionsData.datafeed.setPriceType(newPriceType);
      }

      // 기존 위젯 제거
      if (tvWidgetRef.current) {
        try {
          tvWidgetRef.current.remove();
        } catch (e) {
          console.warn('위젯 제거 중 오류:', e);
        }
        tvWidgetRef.current = null;
      }

      // 상태 업데이트 후 위젯 재생성
      setTimeout(() => {
        // 위젯 재생성 시 새로운 priceType을 직접 전달
        recreateWidget(newPriceType);
      }, 100);
    };

    // 위젯 재생성 함수 - priceType을 매개변수로 받음
    const recreateWidget = (currentPriceType: string) => {
      if (!ep_id || !pairs || !EPs || EPs.length === 0) {
        console.warn('[ChartContainer] 필수 데이터가 없음:', {
          ep_id,
          pairs,
          EPs,
        });
        return;
      }

      if (typeof window === 'undefined' || !window.TradingView) {
        console.warn('[ChartContainer] TradingView 라이브러리가 로드되지 않음');
        return;
      }

      setLoading(true);
      setChartReady(false);

      // 거래쌍 목록 추출
      const exchangePairs = EPs ? EPs.map((ep) => ep.pairs) : [];

      // widgetOptions에 거래쌍 목록 및 심볼 선택 콜백 전달
      const widgetOptionsData = widgetOptions(
        tvWidgetRef,
        pairs,
        ep_id,
        updatechart,
        mutateUpdateChart,
        tab,
        i18n.language,
        isDarkMode,
        token,
        exchangePairs,
        EPs,
        handleDirectNavigation,
        currentChartTheme // 차트 색상 테마
      );

      const tvWidget = new (window as any).TradingView.widget({
        ...widgetOptionsData,
        container_id: 'tv_chart_container',
        datafeed: widgetOptionsData.datafeed,
        library_path: '/charting_library/',
        locale: i18next.language === 'ko' ? 'ko' : 'en',
        fullscreen: false,
        autosize: true,
        theme: isDarkMode ? 'dark' : 'light', // 명시적으로 테마 설정 추가
      });

      // 새로운 priceType 설정
      if (widgetOptionsData?.datafeed?.setPriceType) {
        widgetOptionsData.datafeed.setPriceType(currentPriceType);
      }

      tvWidget.headerReady().then(function () {
        const capitalizedPriceType =
          currentPriceType.charAt(0).toUpperCase() + currentPriceType.slice(1);

        const dropdown = tvWidget.createDropdown({
          title: `Price Type: ${capitalizedPriceType}`,
          tooltip: 'Select the price basis for the chart',
          items: [
            {
              title: 'Last price',
              onSelect: () => {
                handleUpdatePriceType('last');
              },
            },
            {
              title: 'Mark price',
              onSelect: () => {
                handleUpdatePriceType('mark');
              },
            },
            {
              title: 'Index price',
              onSelect: () => {
                handleUpdatePriceType('index');
              },
            },
          ],
        });
      });

      tvWidgetRef.current = tvWidget;

      // 차트 로드 완료 후 이벤트 등록
      tvWidget.onChartReady(() => {
        setLoading(false);
        setChartReady(true);

        try {
          const chartInstance = tvWidget.chart?.();
          if (chartInstance?.onSymbolChanged) {
            chartInstance.onSymbolChanged().subscribe(null, (symbol) => {
              handleSymbolChange(symbol);
            });
          }

          window.addEventListener('message', (event) => {
            if (event.data && event.data.name === 'custom_symbol_selected') {
              if (event.data.symbol) {
                handleSymbolChange(event.data.symbol);
              }
            }
          });

          loadStudy();
        } catch (error) {
          console.error('심볼 이벤트 설정 오류:', error);
        }
      });
    };

    tvWidget.headerReady().then(function () {
      const dropdown = tvWidget.createDropdown({
        title: `Price Type: Last`, // 현재 상태를 제목에 표시
        tooltip: 'Select the price basis for the chart',
        items: [
          {
            title: 'Last price',
            onSelect: () => {
              handleUpdatePriceType('last');
            },
          },
          {
            title: 'Mark price',
            onSelect: () => {
              handleUpdatePriceType('mark');
            },
          },
          {
            title: 'Index price',
            onSelect: () => {
              handleUpdatePriceType('index');
            },
          },
        ],
      });
    });

    tvWidgetRef.current = tvWidget;

    // 차트 로드 완료 후 심볼 검색 이벤트 등록
    tvWidget.onChartReady(() => {
      // 로딩 상태 업데이트
      setLoading(false);
      setChartReady(true);

      // ✅ 로딩 완료 후 플래그 해제 (약간의 딜레이)
      setTimeout(() => {
        isChartLoading.current = false;
      }, 1000);

      try {
        // 첫 렌더링 시 테마가 제대로 적용되지 않는 경우를 위한 폴백
        // 약간의 지연 후 테마 재적용
        setTimeout(() => {
          if (tvWidget.changeTheme) {
            tvWidget.changeTheme(isDarkMode ? 'dark' : 'light');
          }
        }, 100);

        const chartInstance = tvWidget.chart?.();
        if (chartInstance?.onSymbolChanged) {
          chartInstance.onSymbolChanged().subscribe(null, (symbol) => {
            handleSymbolChange(symbol);
          });
        }

        // ✅ onIntervalChanged 이벤트 구독 (HTS 패턴)
        if (chartInstance?.onIntervalChanged) {
          chartInstance.onIntervalChanged().subscribe(null, (interval, timeframeObj) => {
            console.log('[Chart] onIntervalChanged:', interval, timeframeObj);

            // ✅ 캐시 초기화 (TradingView 캐시 문제 해결)
            if ((window as any).__chartResetCache) {
              (window as any).__chartResetCache();
            }

            const data = updatechart || {};
            if (data.resolution !== interval) {
              mutateUpdateChart({
                ...data,
                resolution: interval,
              });
            }
          });
        }

        // 심볼 선택 메시지 수신용 전역 이벤트 리스너
        window.addEventListener('message', (event) => {
          if (event.data && event.data.name === 'custom_symbol_selected') {
            if (event.data.symbol) {
              handleSymbolChange(event.data.symbol);
            }
          }
        });

        // 차트 스터디 로드
        loadStudy();
      } catch (error) {
        console.error('심볼 이벤트 설정 오류:', error);
      }
    });
    } catch (error) {
      console.error('TradingView widget creation failed:', error);
      isChartLoading.current = false;
      setLoading(false);
      setChartReady(false);
    }
  }, [
    ep_id,
    pairs,
    i18n.language,
    isDarkMode,
    EPs,
    token,
    // ✅ tab 제거: 분봉 변경은 setResolution API로 처리, loadchart 재호출 불필요
    updatechart,
    mutateUpdateChart,
    handleDirectNavigation,
    loadStudy,
    handleSymbolChange,
    normalizeSymbol,
  ]);

  // 차트 색상 테마 변경 감지 및 적용
  useEffect(() => {
    if (tvWidgetRef.current && chartReady) {
      console.log('[Chart Theme] Applying theme:', currentChartTheme.name);
      applyChartTheme(tvWidgetRef.current, currentChartTheme);
    }
  }, [selectedTheme, chartReady]);

  useEffect(() => {
    return () => {
      if (tvWidgetRef.current) {
        try {
          tvWidgetRef.current.remove();
        } catch (e) {
          console.warn('Failed to remove TradingView widget', e);
        }
        tvWidgetRef.current = null;
      }

      for (const [, line] of positionLinesRef.current.entries()) {
        try {
          line?.remove?.();
        } catch {
          console.warn('Failed to remove positionLinesRef and orderlines');
        }
      }
      for (const [, line] of liquidationLinesRef.current.entries()) {
        try {
          line?.remove?.();
        } catch {
          console.warn('Failed to remove liquidationLinesRef');
        }
      }
      positionLinesRef.current.clear();
      liquidationLinesRef.current.clear();
      orderlines.length = 0;
    };
  }, []);

  useEffect(() => {
    if (!ep_id || !pairs || chartReady) return;
    setTimeout(() => {
      if (!tvWidgetRef.current) loadchart();
    }, 150);
  }, [ep_id, pairs]);

  useEffect(() => {
    if (!tvWidgetRef.current) return;

    try {
      tvWidgetRef.current.changeTheme?.(isDarkMode ? 'dark' : 'light');
    } catch (e) {
      console.warn('Failed to change theme dynamically', e);
    }
  }, [isDarkMode]);

  const initSocket = () => {
    if (!updatechart?.updatebars) return;
    muateSocket(updatechart);
    loadStudy();
  };

  useEffect(() => {
    initSocket();
  }, [updatechart?.updatebars, tradeModalStore?.showpos]);

  useEffect(() => {
    if (!tvWidgetRef.current || !tradeModalStore?.showpos || !position?.length)
      return;

    let interval: NodeJS.Timeout | null = null;

    const updatePnl = () => {
      if (document.visibilityState === 'hidden') return;

      const newPnlValues: Record<string | number, string> = {};
      let updated = false;

      for (const item of position) {
        if (!item?.id) continue;

        const currentPrice = tradePrice || getPrice(item.exchange_pairs_id);
        // console.log('pnlText currentPrice', currentPrice)
        if (!currentPrice) continue;

        const amount = item?.amount * item?.leverage;
          // item.main_sub === 'M'
          //   ? item.amount / item.leverage
          //   : item.amount * item.price / item.leverage;

            

        try {
          let pnl = truncateWithComma(
            BigNumber(
              item.long_short === 'S'
                ? BigNumber(item.price).minus(currentPrice)
                : BigNumber(currentPrice).minus(item.price)
            )
              .multipliedBy(amount)
              .toNumber(),
            4
          );

          if (+pnl > 0) pnl = `+${pnl}`;
          if (pnlValues[item.id] !== pnl) {
            newPnlValues[item.id] = pnl;
            updated = true;
          }
        } catch (err) {
          console.error('PNL calc error:', err);
        }
      }

      if (updated) {
        setPnlValues((prev) => ({ ...prev, ...newPnlValues }));
      }
    };

    interval = setInterval(updatePnl, 300);

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        updatePnl();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      if (interval) clearInterval(interval);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [position, tradeModalStore?.showpos]);

  useEffect(() => {
    if (!tvWidgetRef.current || !chartReady || !tradeModalStore?.showpos)
      return;

    for (const item of position || []) {
      if (!item?.id) continue;

      const posLine = positionLinesRef.current.get(item.id);
      if (!posLine) continue;

      const pnlText = pnlValues[item.id] || '0';
      // console.log('pnlText 1', pnlText)
      posLine.setText('P&L ' + pnlText);
    }
  }, [pnlValues]);

  return (
    <ChartContainerWrapper>
      <EditCheckPositionModal
        open={open}
        setOpen={setOpen}
        long_short={long_short}
        rawOrderPrice={orderPrice}
        orderId={orderId}
        orderItem={orderItem}
      />

      <View
        ref={ref}
        id={'tv_chart_container'}
        className={'TVChartContainer'}
        style={{
          width: '100%',
          height: '100%',
          background: drawerBgColor,
        }}
      />
      {isDragging && (
        <View
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(255,255,255,0.1)',
            zIndex: 999,
          }}
        ></View>
      )}
    </ChartContainerWrapper>
  );
};

export default React.memo(ChartContainer, (prevProps, nextProps) => {
  return prevProps.isDragging === nextProps.isDragging;
});
